import { AppModule } from 'app/module';
import './styles.scss';
import Template from './template.hbs';

const MIN_ITEMS_TO_COLLAPSE = 4;

export class MobileKeyfactBox extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        if (this.dom.keyfactBoxItems.length >= MIN_ITEMS_TO_COLLAPSE) {
            this.toggleKeyfactBox(false);
        }
    }

    domBindings() {
        this.dom.companyLink = this.dom.el.querySelector('.m-mobileKeyfactBox__companyLink');
        this.dom.keyfactBoxItems = this.dom.el.querySelectorAll('.m-mobileKeyfactBox__keyfactBoxList li');
        this.dom.showMoreButton = this.dom.el.querySelector('.m-mobileKeyfactBox__showMore');
        this.dom.showLessButton = this.dom.el.querySelector('.m-mobileKeyfactBox__showLess');
    }

    getPropsFromDom() {
        return {
            keyfactBox: {
                job: {
                    id: this.dom.el.getAttribute('data-id'),
                    employmentTypes: this.dom.el.getAttribute('data-job-employmenttypes') ?? false,
                    salaryRange: this.dom.el.getAttribute('data-job-salaryrange') ?? false,
                    isHomeOffice: this.dom.el.getAttribute('data-job-homeoffice') === 'true',
                    jobLevel: this.dom.el.getAttribute('data-job-level') ?? false,
                    locations: this.dom.el.getAttribute('data-job-locations') ?? false,
                    date: this.dom.el.getAttribute('data-job-date') ?? false,
                    companyIsEmploymentAgency:
                        this.dom.el.getAttribute('data-job-company-is-employment-agency') === 'true',
                    isChiffre: this.dom.el.getAttribute('data-is-chiffre') === 'true',
                },
                company: {
                    isLinkable: !!this.dom.companyLink,
                    name: this.dom.el.getAttribute('data-company-name') ?? 'Arbeitgeber verdeckt',
                    employees: this.dom.el.getAttribute('data-company-employees') ?? false,
                    mainLocation: this.dom.el.getAttribute('data-company-location') ?? false,
                    slug: this.dom.el.getAttribute('data-company-slug') ?? false,
                },
                hideWatchlistLoginInfo: !this.dom.watchlistLoginInfo,
                isPreview: this.dom.el.getAttribute('data-is-preview') === 'true',
                keyfactBoxCollapsed: this.dom.actions
                    ? this.dom.actions.classList.contains('m-mobileKeyfactBox__actions--keyfactBoxCollapsed') : false,
                keyfactBoxExpanded: this.dom.actions
                    ? this.dom.actions.classList.contains('m-mobileKeyfactBox__actions--keyfactBoxExpanded') : false,
            },
        };
    }

    domEvents() {
        if (this.dom.showMoreButton) {
            this.dom.showMoreButton.addEventListener('click', () => {
                this.toggleKeyfactBox(true);
            });
        }

        if (this.dom.showLessButton) {
            this.dom.showLessButton.addEventListener('click', () => {
                this.toggleKeyfactBox(false);
            });
        }
    }

    toggleKeyfactBox(expand = true) {
        this.updateProps({
            keyfactBoxExpanded: expand,
            keyfactBoxCollapsed: !expand,
        }, true);
    }
}
